// transform FROM LoggedOut TO LoggedOut 
import { AuthState, isResetPasswordRequestState } from "./authState";
import { Updater, any, nothing, wait, Widget } from 'widgets-for-react';
import { Api, reset_password_request, } from "./api_to_state";
import { reset_password_request_form, reset_password_request_success } from "./reset_password_request_form";
import { options } from "./utils";

export function resetPasswordRequest(
  options: options,
  api: Api,
  s0: AuthState,
  contactLink: JSX.Element
): Widget<Updater<AuthState>> {
    if(isResetPasswordRequestState(s0)) { 
      return any<Updater<AuthState>>([
      s0.resetPasswordRequestState == "reset password request" ||
      s0.resetPasswordRequestState == "reset password request - error email not valid" ||
        s0.resetPasswordRequestState == "reset password request - error form validation" ?
        reset_password_request_form(options, s0, false, contactLink, false) :
        s0.resetPasswordRequestState == "reset password request - error email not found" ||
        s0.resetPasswordRequestState == "reset password request - error too many attempts" ?
        reset_password_request_form(options, s0, false, contactLink, true) :
        s0.resetPasswordRequestState == "reset password request - api error" ?
          any<Updater<AuthState>>([
            wait(500, { key: "login-widget-reset-password-request-promise" })(() => (s : AuthState) : AuthState => isResetPasswordRequestState(s) && s.resetPasswordRequestState != "reset password request - api error" ? s : ({ ...s, resetPasswordRequestState: "reset password request - resetting" })),
            reset_password_request_form(options, s0, true, contactLink, true)
          ]) :
          s0.resetPasswordRequestState == "reset password request - resetting" ?
            any<Updater<AuthState>>([
              reset_password_request(api, s0.login_data),
              reset_password_request_form(options, s0, true, contactLink, false).never()
            ]) :
            s0.resetPasswordRequestState == "reset password request - error user not activated" ||
              s0.resetPasswordRequestState == "reset password request - success" ?
              any<Updater<AuthState>>([
                reset_password_request_success(options, s0, contactLink)
              ]) :
              nothing()
      ])
  }
    else {
      return nothing()
    }
}
